import axios from "axios";
import axiosInstance from "./axiosInstance";

class TipoAtoInfralegalApi {
  cancelTokens = {
    getTiposAtoInfralegal: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async getTiposAtoInfralegal() {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getTiposAtoInfralegal = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/tipos_ato_infralegal`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getTiposAtoInfralegal = null;

    return data;
  }
}

export default TipoAtoInfralegalApi;
